
  class StyliticsHandler {
  constructor(styliticsContainerId) {

    if (!document.querySelector(`#${styliticsContainerId}`)) {
      console.log('styliticsContainerId Element does not exist!');
    }

    this.containerId = styliticsContainerId;

    this.outfitClickedCallback = this.outfitClickedCallback.bind(this);
  }

  async sizeButtonClickCallback(data) {
    console.log("Size button clicked:", data);

    let submitButton = data?.element;

    if (submitButton?.classList.contains("stylitics-atc-size-onesize")) {
      submitButton.classList.add("stylitics-atc-size-onesize--loading");
      submitButton.innerHTML = "Adding...";
      submitButton.disabled = true;
      submitButton.setAttribute("aria-disabled", true);
    }

    let cartItems = document.querySelector("cart-items");

    let formData = {
      items: [
        {
          id: data?.item_size_id,
          quantity: 1,
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (response.message === "Parameter Missing or Invalid") {
            console.log("Please select a size.");
          } else {
            console.log(response.description);
          }
          return;
        }

        cartItems.thirdPartyUpdateCart();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (submitButton?.classList.contains("stylitics-atc-size-onesize")) {
          submitButton.classList.remove("stylitics-atc-size-onesize--loading");
          submitButton.innerHTML = "Add to bag";
          submitButton.disabled = false;
          submitButton.setAttribute("aria-disabled", false);
        }
      });
  }

  styleSingleSizeButtons() {
    const sizeButtons = document.querySelectorAll("button.stylitics-atc-size");

    sizeButtons.forEach((button) => {
      if (button.innerHTML === "ONE SIZE") {
        const parent = button.closest(".stylitics-atc-details");

        if (parent) {
          parent.classList.add("stylitics-atc-details-single-size");
        }

        button.textContent = "Add to bag";
        button.classList.add("stylitics-atc-size-onesize");
      }
    });
  }

  addIndexClassesToStyliticsCards(parentElementSelector) {
    const ul = document.querySelector(
      `${parentElementSelector} ul.stylitics-ui-carousel-card-list`
    );

    if (!ul) {
      console.warn(
        `No ${parentElementSelector} ul.stylitics-ui-carousel-card-list found on the page.`
      );
      return;
    }

    const liElements = ul.querySelectorAll("li.stylitics-ui-carousel-card");

    liElements.forEach((li, index) => {
      li.classList.add(`stylitics-ui-carousel-card-index-${index}`);
      li.classList.add(`stylitics-ui-carousel-card-index`);
      li.setAttribute("data-index", index);
    });
  }

  async loadDataCallback(data) {
    const promises = [];

    data.items.forEach((item) => {
      console.log(item);

      const remoteId = item?.remote_id;
      if (!remoteId) return;

      if(!item?.stocked) return;

      const promise = fetch(`/products/${remoteId}.js`)
      .then(res => {
              if (!res.ok) {
                // Server responded with an error status (e.g., 404, 500)
                throw new Error(`Fetch error: ${res.status} ${res.statusText}`);
              }
              return res.json();
            })
        .then((product) => ({
          remoteId: item.remote_id,
          variants: product.variants.map((variant) => ({
            name: product.title,
            remoteId: variant.id.toString(),
            sizeMeta: [
              {
                remoteId: variant.id.toString(),
                size: variant.option1,
                inStock: variant.available,
              },
            ],
          })),
        }));

      promises.push(promise);
    });

    const enrichedData = await Promise.all(promises);
    console.log(enrichedData);
    data.enrichItems(enrichedData);
  }

  async outfitClickedCallback(data) {
    
    console.log("clicked outfit...");
    console.log(data);
            
    // First, add index classes + data attributes to li
    this.addIndexClassesToStyliticsCards(`#${this.containerId}`);

    setTimeout(() => {
      console.log("This runs after 2 seconds");
        this.styleSingleSizeButtns();
      }, 500);
  }

  async addTCartClickedCallback(data){}

  async styleSingleSizeButtns(){

                  //fins all single buttns in this cnatiner
                  // Select all buttons
                    const sizeButtons = document.querySelectorAll("button.stylitics-atc-size");

                    // Loop through each button
                    sizeButtons.forEach(button => {



                      if(button.innerHTML === "ONE SIZE"){

                          const parent = button.closest(".stylitics-atc-details");

                          // Add a new class to the parent
                          if (parent) {
                            parent.classList.add("stylitics-atc-details-single-size");
                          }

                        button.textContent = "Add to bag";                 // change inner text
                        button.classList.add("stylitics-atc-size-onesize"); // add new class
                      }
                    
                    });


                    //with each ne change the inner text and add a style class

                } // END styleSingleSizeButtns

}
